// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2nDKq","addWidgetButton":"Header_addWidgetButton__ctKpr","dashboardTabs":"Header_dashboardTabs__1pTDp","active":"Header_active__2-Woj"};